import type { CorpusCatalogueFields } from "@shared/types/corpus/api.ts";
import { useAsyncData, type AsyncDataResult } from "../../../../hooks/useAsyncData";
import { getCorpusCatalogueFields } from "../../../../lib/corpusApi";

/** The corpus' ingested papers by health field. */
export function useCatalogueFields(): AsyncDataResult<CorpusCatalogueFields> {
  return useAsyncData(getCorpusCatalogueFields);
}
